<template>
  <div
    class="bg-white form-sample p-3 user-view h-auto mt-3 activity-type-create col-12"
  >
    <div class="d-flex title-bar-block mb-3">
      <div class="icon-block me-4">
        <button id="cancel-user"
          variant="none"
          v-b-tooltip.hover
          :title="$backLabel()"
          @click="cancel()"
        >
          <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
        </button>
      </div>
      <div class="text">
        <span class="me-2">{{ title }}</span>
      </div>
    </div>
    <b-overlay :show="submitting || basic_updating" rounded="sm">
      <b-form @submit.stop.prevent="createOrUpdate">
        <b-row>
          <b-col cols="12" md="6">
            <label class="mb-3"
              ><strong
                >{{ $translate("first_name") }}<span class="red">*</span></strong
              >
            </label>
            <b-form-input
              id="input-firstName"
              v-custom-validation="$textRequired()"
              v-model="model.firstName"
              name="firstName"
              required
              trim
            >
            </b-form-input>
          </b-col>
          <b-col cols="12" md="6" class="mt-3 mt-md-0">
            <label class="mb-3"
              ><strong
                >{{ $translate("last_name") }}<span class="red">*</span></strong
              >
            </label>
            <b-form-input
              id="input-lastName"
              v-model="model.lastName"
              name="lastName"
              v-custom-validation="$textRequired()"
              required
              trim
            ></b-form-input>
          </b-col>
          <b-col cols="12" md="12" class="mt-3" v-if="isNew">
            <label for="input-email" class="mb-3"
              ><strong
                >{{ $translate("email") }}<span class="red">*</span></strong
              >
            </label>
            <b-form-input
              id="input-email"
              v-model="model.email"
              type="email"
              v-custom-validation="$emailRequired()"
              name="email"
              required
              trim
            ></b-form-input>
          </b-col>
          <b-col cols="12" :md="isAdmin && !isNew && model.isLocked ? 6 : 12">
            <user-roles
              :all-roles="roles"
              v-model="model.roles"
              label-class="font-weight-bold"
            ></user-roles>
          </b-col>
          <b-col
            cols="12"
            md="6"
            class="mt-3"
            v-if="isAdmin && !isNew && model.isLocked"
          >
            <label class="mb-3"
              ><strong>{{ $translate("locked") }}</strong>
            </label>
            <b-col class="form-check form-switch mt-3">
              <input
                class="form-check-input m-0"
                @change="unlockUserAccount()"
                v-model="model.isLocked"
                type="checkbox"
                role="switch"
                id="flexSwitchCheckDefault"
                v-b-tooltip:hover
                :title="$translate('unlock_user_title')"
              />
            </b-col>
          </b-col>
          <b-col cols="12" md="6" class="mt-4" v-if="!isNew && !loggedUser">
            <div class="form-check">
              <label class="form-check-label lh-base">
                <input
                  type="checkbox"
                  :disabled="
                    !(user.is_blacklisted
                      ? hasPermissionRestore
                      : hasPermissionDisable)
                  "
                  class="form-check-input top-2"
                  id="checkbox-model.is_blacklisted"
                  v-model="model.is_blacklisted"
                  name="checkbox-model.is_blacklisted"
                  :value="1"
                  :unchecked-value="false"
                />
                {{ $translate("disable") }}
                <i class="input-helper"></i>
              </label>
            </div>
          </b-col>

          <b-col cols="12" class="d-flex gap-2 justify-content-center mt-4">
            <b-button id="submit-user-create"
              class="btn btn-info btn-fw me-2"
              type="submit"
              v-if="hasPermissionCreate && !model.id"
              variant="primary"
              :disabled="submitting ? true : false"
              >{{ createLabel }}</b-button
            >
            <b-button id="submit-user-update"
              class="btn btn-info btn-fw me-2"
              type="submit"
              v-if="hasPermissionUpdate && model.id"
              variant="primary"
              :disabled="submitting ? true : false"
              >{{ updateLabel }}</b-button
            >
            <b-button
              id="user-delete"
              @click="deleteUser()"
              size="fw"
              v-if="hasPermissionDelete && this.model.id"
              class="float-right"
              variant="delete-button"
            >
              {{ $translate("delete_user") }}
            </b-button>
            <b-button
            id="cancel-user-form"
              @click="cancel()"
              variant="info"
              size="fw"
              class="float-right"
              :disabled="basic_updating || email_updating || password_updating"
              >{{ $cancelLabel() }}</b-button
            >
          </b-col>
        </b-row>
      </b-form>
    </b-overlay>
    <b-card-text v-if="!isNew">
      <div>
        <b-overlay :show="email_updating" rounded="sm">
          <b-form @submit.prevent="updateEmail()" data-vv-scope="email">
            <b-row>
              <b-col cols="12" class="mt-2">
                <label class="mb-3"
                  ><strong>{{ $translate("email") }}</strong></label
                >
                <b-form-input
                  id="input-email-user"
                  v-model="model.email"
                  name="email"
                  type="email"
                  required
                  trim
                ></b-form-input>
              </b-col>

              <b-col cols="12" class="mb-2 d-flex mt-4 justify-content-center">
                <b-button
                id="update-email-btn"
                  size="fw"
                  variant="info"
                  v-if="hasPermissionUpdate"
                  @click="updateEmail()"
                  class="float-right"
                  >{{
                    $translate("update_email")
                  }}</b-button
                >
              </b-col>
            </b-row>
          </b-form>
        </b-overlay>
      </div>
    </b-card-text>
    <b-card-text v-if="!isNew">
      <div>
        <b-overlay :show="email_updating" rounded="sm">
          <b-form @submit.prevent="updateEmail()" data-vv-scope="email">
            <b-row>
              <b-col md="12" cols="12">
                <label class="mb-3 mt-3" label-for="input-new-password"><strong>{{ $translate('new_password')
                }}</strong></label>
                <b-input-group class="password-field-container">
                <b-form-input required id="input-new-password" :type="showNewPassword ? 'text' : 'password'" v-custom-validation="$textRequired()"
                    v-model="model.password" @input="validatePassword">
                </b-form-input>
                <b-input-group-append class="eye-btn">
                    <i @click="showNewPassword = !showNewPassword"
                        :class="showNewPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>

                    </b-input-group-append>
                </b-input-group>
                <!-- <p class="muted-text">{{ $translate('password_pattern') }}</p> -->
                <b-form-invalid-feedback v-if="model.password?.length > 0" class="row" style="display:flex !important;">
                  <span class="col-md-6" :style="{ color: hasUppercase ? 'green' : 'red' }">
                  <i :class="hasUppercase? 'fa fa-check': 'fa fa-x'"></i>
                  one uppercase character
                  </span>
                  <span class="col-md-6" :style="{ color: hasLowercase ? 'green' : 'red' }">
                  <i :class="hasLowercase? 'fa fa-check': 'fa fa-x'"></i>
                  one lowercase character
                  </span>
                  <span class="col-md-6" :style="{ color: hasSpecialCharacter ? 'green' : 'red' }">
                  <i :class="hasSpecialCharacter? 'fa fa-check': 'fa fa-x'"></i>
                  one special character
                  </span>
                  <span class="col-md-6" :style="{ color: model.password?.length >= min_password_length ? 'green' : 'red' }">
                  <i :class="model.password?.length >= min_password_length? 'fa fa-check': 'fa fa-x'"></i>
                  {{ min_password_length }} characters minimum
                  </span>
                  <span class="col-md-6" :style="{ color: hasNumber ? 'green' : 'red' }">
                  <i :class="hasNumber? 'fa fa-check': 'fa fa-x'"></i>
                  one number
                  </span>
              </b-form-invalid-feedback>
            </b-col>

              <b-col cols="12" class="mb-2 d-flex mt-4 justify-content-center">
                <b-button
                id="reset-password-admin"
                  size="fw"
                  variant="info"
                  v-if="hasPermissionUpdate"
                  @click="updatePassword()"
                  class="float-right"
                  :disabled="(!(hasNumber && hasUppercase && hasLowercase && hasSpecialCharacter) ? true : false)"
                  >{{
                    $translate("reset_password_admin")
                  }}</b-button
                >
              </b-col>
            </b-row>
          </b-form>
        </b-overlay>
      </div>
    </b-card-text>
  </div>
</template>

<script>
import popupMixins from "@/mixins/popupMixins";
import utilityMixins from "@/mixins/utilityMixins";
import UserRoles from "@/components/UserRoles";
import permissionsMixins from "@/mixins/permissionsMixins";
export default {
  name: "users-view",
  components: { UserRoles },
  mixins: [popupMixins, utilityMixins, permissionsMixins],
  data() {
    return {
      tabIdx: 0,
      loaded: true,
      model: {
        id: 0,
        firstName: "",
        lastName: "",
        email: "",
        attempt_count: null,
        // password: '',
        // confirmPassword: '',
        roles: [],
      },
      submitting: false,
      basic_updating: false,
      email_updating: false,
      password_updating: false,
      showNewPassword: false,
      hasNumber: false,
      hasUppercase: false,
      hasLowercase: false,
      hasSpecialCharacter: false,
    };
  },
  props: ["item"],
  async created(){
    await this.$store.dispatch("roles/fetch_roles");
  },
  computed: {
    componentName() {
      return this.$translate("user");
    },
    isNew() {
      return this.model.id === 0;
    },
    isAdmin() {
      return this.$store.state.user.roles[0].role_id == 1;
    },
    loggedUser() {
      const userId = this.model.id;
      return this.$store.state.user.id == userId;
    },
    title() {
      return this.model.id
        ? this.$translate("view_user")
        : this.$translate("new_user");
    },
    user() {
      return this.$store.state.users.user;
    },
    createLabel() {
      if (this.submitting) {
        return this.$translate("creating");
      } else {
        return this.$createLabel();
      }
    },
    updateLabel() {
      if (this.submitting && this.model.id) {
        return this.$translate("updating");
      } else {
        return this.$updateLabel();
      }
    },
    roles() {
      return this.$store.state.roles.roles;
    },
    min_password_length() {
            return this.$minPasswordLength ? this.$minPasswordLength : 8;
    },
  },

  watch: {
    model: {
      handler: function (val) {
        console.log("value", val);
      },
      deep: true,
    },

    user: function (user) {
      console.log("user-2", user);
      let {
        id,
        email,
        is_blacklisted,
        is_locked: isLocked,
        first_name: firstName,
        last_name: lastName,
        roles: userRoles,
        // permissions,
      } = user;
      let roles = [...userRoles].map(({ role: { name } }) => name);

      console.log("roles", roles);
      this.model = {
        id,
        isLocked,
        email,
        is_blacklisted,
        firstName,
        lastName,
        roles,
      };
      this.loaded = !this.loaded;
      console.log("model-2", this.model);
    },
  },

  methods: {
    async unlockUserAccount() {
      try {
        this.submitting = false;
        const userId = this.model.id;
        const title = `${this.$translate("unlock_user")}`;
        const message = `${this.$translate("unlock_user_note")}`;

        const result = await this.confirmMessage(title, message);
        if (!result) {
          this.model.isLocked = 1;
        } else {
          const is_locked = 0;
          await this.$store.dispatch("users/unlockUserAccount", {
            is_locked,
            userId,
          });
          this.doToast(
            this.$translate("success"),
            this.$translate("account_unlock"),
            "success"
          );
        }
      } catch (error) {
        // console.log("adda", error.response)
        this.doToast(this.$translate("error"), error.message, "danger");
      } finally {
        this.updating = false;
      }
    },
    cancelLabel1() {
      return this.cancelLabel();
    },
    cancel() {
      this.$router.push("/ams/users");
    },
    nextTick() {
      return new Promise((resolve) =>
        this.$nextTick(() => {
          resolve();
        })
      );
    },
    async createOrUpdate() {
      this.submitting = true;
      this.basic_updating = true;
      this.rolesError = null;
      try {
        const valid = await this.$validator.validate("basic.*");
        if (!valid) {
          throw new Error("Not valid!");
        }
        const model = { ...this.model };
        console.log("upfaying", model);
        const action = model.id ? "updateBasicInfo" : "createUser";
        const path = `users/${action}`;
        const {
          id: userId,
          firstName: first_name,
          lastName: last_name,
          is_blacklisted,
          roles,
        } = this.model;
        const updateUser = {
          userId,
          first_name,
          last_name,
          is_blacklisted,
          roles,
        };
        await this.$store.dispatch(path, model.id ? updateUser : model);
        console.log("model.id", model.id);
        this.$router.push({ name: "users" });
        await this.nextTick();
        if (model.id !== 0) {
          this.genericToast(
            this.componentName,
            this.$translate("updated"),
            "success",
            `${this.componentName} ${this.$translate("update_alert")}`
          );
        } else {
          this.genericToast(
            this.componentName,
            this.$translate("created"),
            "success",
            `${this.componentName} ${this.$translate("create_alert")}`
          );
        }
      } catch (error) {
        this.doToast(this.$translate("error"), error.message, "danger");
      } finally {
        this.submitting = false;
        this.basic_updating = false;
      }
    },
    async updateEmail() {
      try {
        console.log("this.model", this.model);
        this.email_updating = true;
        const valid = await this.$validator.validate("email.*");
        if (!valid) {
          throw new Error("Invalid Email!");
        }
        const { id: userId, email } = this.model;
        const res = await this.$store.dispatch("users/updateEmail", {
          userId,
          email,
        });

        console.log(res);
        this.genericToast(
          this.componentName,
          this.$translate("updated"),
          "success",
          this.$translate("user_email_alert")
        );
      } catch (error) {
        console.log("updateEmail", error.message);
        this.doToast(
          this.$translate("error"),
          error && error.message,
          "danger"
        );
      } finally {
        this.email_updating = false;
      }
    },

    async deleteUser() {
      // Initializing key variables
      try {
        const model = {
          ...this.model,
        };
        const path = "users/deleteUser";

        // Generate and display confirmation prompt
        const title = `${this.$translate("delete_user")}?`;
        const message = `${this.$translate("delete_note")} ${model.firstName}?`;

        const result = await this.confirmMessage(title, message);
        if (result) {
          this.submitting = true;
          await this.$store.dispatch(path, model.id);
          console.log("userresult", result);
          this.$router.push({ name: "users" });
          this.$nextTick(() => {
            this.genericToast(
              this.componentName,
              this.$translate("deleted"),
              "success",
              this.$translate("user_delete_alert")
            );
          });
        }
      } catch (error) {
        this.doToast(
          this.$translate("error"),
          this.$translate("unable_to_delete_user"),
          "danger"
        );
      } finally {
        this.submitting = false;
      }
    },

    async updatePassword() {
            console.log("CustomerProfile", this.model)
            try {
              this.submitting = true;
                this.updating = true
                // const userData = this.$store.state.user
                const userId = this.model.id
                // const is_first_time_login = 0
                const {password} =
                    this.model

                await this.$store.dispatch('users/updatePassword', {
                    password,
                    userId
                })
              
                this.doToast(this.$translate('success'), this.$translate('password_reseted'), 'success')
            
            } catch (error) {
                this.doToast(this.$translate('error'), error.response ? error.response.data.error.message.password ? error.response.data.error.message.password[0] : error.response.data.error.message.current_password : error.message, 'danger')
            } finally {
                this.updating = false;
                this.submitting = false;
            }
        },
        validatePassword() {
            // Check for uppercase letter
            this.hasNumber = /[0-9]/.test(this.model.password);

            this.hasUppercase = /[A-Z]/.test(this.model.password);
            
            // Check for lowercase letter
            this.hasLowercase = /[a-z]/.test(this.model.password);
            
            // Check for special character
            this.hasSpecialCharacter = /[$@$!%*?&]/.test(this.model.password);
        }
  },
   mounted() {
    
    this.$store.dispatch("roles/fetch", {
      query: "",
      page: 1,
    });

    this.$store.dispatch("permissions/all");
    if (this.$route.params.id !== 0) {
      this.$store.dispatch("users/fetchUser", this.$route.params.id);
    }
  },

};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>